import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import PlayerBuffering from './controls/buffering/PlayerBuffering'

import './TouchPlayer.css'

export default class TouchPlayer extends React.PureComponent {

	static propTypes = {
		poster: PropTypes.string.isRequired,
		width: PropTypes.number.isRequired,
		height: PropTypes.number.isRequired,
		src: PropTypes.string.isRequired,
		onLoad: PropTypes.func
	}

	constructor(props) {

		super(props)
		this.state = {
			isInitiated: false,
			isBuffering: false,
			isPlaying: false
		}

		this.onTouchEnd = this.onTouchEnd.bind(this)
		this.onTouchStart = this.onTouchStart.bind(this)
		this.onTouchmove = this.onTouchmove.bind(this)

		this.onPlaying = this.onPlaying.bind(this)
		this.onPause = this.onPause.bind(this)
		this.onBuffering = this.onBuffering.bind(this)

	}

	componentDidMount() {
		// this.inlineVideoRef.load()
		// this.inlineVideoRef.play()
	}

	onTouchStart() {
		// let's presume the touch-start will result in a click
		this.isValidTouchClickAction = true
	}

	onTouchmove() {
		// cancel click action on movement (i.e. scroll etc.)
		this.isValidTouchClickAction = false
	}

	onTouchEnd() {

		// check if the click action is yet valid (i.e. no movment)
		if ( !this.isValidTouchClickAction ) { return }
		// clean up flag
		this.isValidTouchClickAction = false

		// start playback
		if (!this.state.isPlaying) {
			if (!this.state.isInitiated) {
				this.inlineVideoRef.load()
			}
			this.inlineVideoRef.play()

			this.setState(state => ({
				isInitiated: true,
				isPlaying: true,
				isBuffering: true
			}))

		} else {

			this.inlineVideoRef.pause()
			this.setState(state => ({
				isPlaying: false,
				isBuffering: false
			}))
		}
	}

	onPlaying() {
		this.setState({
			isInitiated: true,
			isBuffering: false,
			isPlaying: true
		})
		this.props.onPlaying && this.props.onPlaying()
	}

	onBuffering() {
		this.setState({
			isBuffering: true
		})
	}

	onPause() {
		this.props.onPause && this.props.onPause()
		this.setState({
			isBuffering: false,
			isPlaying: false
		})
	}

	render() {

		const classNames = classnames('touch-player', {
			'player--buffering': this.state.isBuffering,
			'player--initiated': this.state.isInitiated,
			'player--playing': this.state.isPlaying
		})

		const image = this.state.isPlaying ? null : (
			<img
				src={ this.props.poster }
				width={ this.props.width }
				height={ this.props.height }
				onLoad={ this.props.onLoad }
				alt="poster"
			/>
		)

		return (
			<div
				className={ classNames }
				style={ this.props.style }

				onTouchStartCapture={ this.onTouchStart }
				onTouchMoveCapture={ this.onTouchmove }
				onTouchEndCapture={ this.onTouchEnd }
				>
				<video
					width={ this.props.width }
					height={ this.props.height }
					ref={ ref => this.inlineVideoRef = ref }
					preload="auto"
					poster={ this.props.poster }
					onPlaying={ this.onPlaying }
					onWaiting={ this.onBuffering }
					onEnded={ this.props.onEnded }
					onPause={ this.onPause }
					src={ this.props.src }
					loop={this.props.loop}
					playsInline={false}
				/>
				{ image }

				<PlayerBuffering />
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/player/TouchPlayer.jsx